import classNames from 'classnames';
import React from 'react';

/**
 * Chèn <wbr> để cho phép ngắt dòng **trước các dấu**, sao cho dấu nằm đầu dòng sau.
 * Nếu isSmallerSide=true, sẽ giảm kích thước font cho phần text từ ký tự break trở đi.
 */
interface BreakProps {
    text: string,
    isSmallerSide?: boolean
}

export default function insertBreakOpportunities({ text, isSmallerSide = false }: BreakProps): React.ReactNode[] {
    const BREAK_CHARS = ['（', '(', '・', '～', '~'];
    const regex = new RegExp(`(${BREAK_CHARS.map(c => `\\${c}`).join('|')})`, 'g');

    const result: React.ReactNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    let key = 0;
    let smallerStarted = false;

    while ((match = regex.exec(text)) !== null) {
        const index = match.index;

        // Phần text trước dấu
        if (lastIndex < index) {
            const segment = text.slice(lastIndex, index);
            result.push(segment);
        }

        // Điểm break + ký tự
        result.push(<wbr key={`wbr-${key++}`} />);
        result.push(
            isSmallerSide ?
                (
                    <span
                        key={`char-${key++}`}
                        className={classNames(isSmallerSide && 'xsm:text-fs-mid14 point-375:text-fs-mid11 text-[10px]')}
                    >
                        {match[0]}
                    </span>
                ) :
                (
                    <React.Fragment key={`char-${key++}`}>
                        {match[0]}
                    </React.Fragment>
                )
        );

        // Bật flag sau break
        if (isSmallerSide) {
            smallerStarted = true;
        }

        lastIndex = index + match[0].length;
    }

    // Phần còn lại sau dấu cuối
    if (lastIndex < text.length) {
        const tail = text.slice(lastIndex);
        result.push(
            isSmallerSide ?
                (
                    <span
                        key={`char-${key++}`}
                        className={classNames(isSmallerSide && 'xsm:text-fs-mid14 point-375:text-fs-mid11 text-[10px]')}
                    >
                        {tail}
                    </span>
                ) :
                (
                    <React.Fragment key={`char-${key++}`}>
                        {tail}
                    </React.Fragment>
                )
        );
    }

    // Nếu không có match, trả về nguyên text
    if (result.length === 0) {
        return [text];
    }

    return result;
}
